/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { BigCommerceCustomerGroupRef } from "./BigCommerceCustomerGroupRef";
import {
  BigCommerceCustomerGroupRefFromJSON,
  BigCommerceCustomerGroupRefFromJSONTyped,
  BigCommerceCustomerGroupRefToJSON,
  BigCommerceCustomerGroupRefToJSONTyped,
} from "./BigCommerceCustomerGroupRef";

/**
 *
 * @export
 * @interface BigCommerceGroupAccessorialRule
 */
export interface BigCommerceGroupAccessorialRule {
  /**
   *
   * @type {Array<BigCommerceCustomerGroupRef>}
   * @memberof BigCommerceGroupAccessorialRule
   */
  customerGroups: Array<BigCommerceCustomerGroupRef>;
  /**
   *
   * @type {string}
   * @memberof BigCommerceGroupAccessorialRule
   */
  accessorial: string;
  /**
   *
   * @type {boolean}
   * @memberof BigCommerceGroupAccessorialRule
   */
  require: boolean;
}

/**
 * Check if a given object implements the BigCommerceGroupAccessorialRule interface.
 */
export function instanceOfBigCommerceGroupAccessorialRule(
  value: object,
): value is BigCommerceGroupAccessorialRule {
  if (!("customerGroups" in value) || value["customerGroups"] === undefined)
    return false;
  if (!("accessorial" in value) || value["accessorial"] === undefined)
    return false;
  if (!("require" in value) || value["require"] === undefined) return false;
  return true;
}

export function BigCommerceGroupAccessorialRuleFromJSON(
  json: any,
): BigCommerceGroupAccessorialRule {
  return BigCommerceGroupAccessorialRuleFromJSONTyped(json, false);
}

export function BigCommerceGroupAccessorialRuleFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): BigCommerceGroupAccessorialRule {
  if (json == null) {
    return json;
  }
  return {
    customerGroups: (json["customerGroups"] as Array<any>).map(
      BigCommerceCustomerGroupRefFromJSON,
    ),
    accessorial: json["accessorial"],
    require: json["require"],
  };
}

export function BigCommerceGroupAccessorialRuleToJSON(
  json: any,
): BigCommerceGroupAccessorialRule {
  return BigCommerceGroupAccessorialRuleToJSONTyped(json, false);
}

export function BigCommerceGroupAccessorialRuleToJSONTyped(
  value?: BigCommerceGroupAccessorialRule | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    customerGroups: (value["customerGroups"] as Array<any>).map(
      BigCommerceCustomerGroupRefToJSON,
    ),
    accessorial: value["accessorial"],
    require: value["require"],
  };
}
